import { SystemField } from "./system-field";

export class PrintedInvoiceHistory extends SystemField {
     
     sales_order_id?:string;
     sub_total?:number;
     ordering?:number;
     print_datetime?:string;
}
